export const systemColours = [
  'primary',
  'secondary',
  'president',
  'president-light',
  'president-lighter',
  'grey',
  'grey-light',
  'grey-lighter',
  'gold',
  'vermilion',
  'vermilion-dark',
  'purple',
  'grape',
  'red',
  'red-light',
  'red-dark',
  'red-darker',
  'orange',
  'orange-light',
  'orange-dark',
  'orange-darker',
  'green',
  'green-light',
  'green-dark',
  'blue',
  'petrol',
  'yellow',
  'white',
  'rivergreen',
] as const

export type SystemColour = (typeof systemColours)[number]

//Shades ranging from 0 to 100 with 500 exception for rivergreen
type SystemShades = 0 | 10 | 20 | 30 | 40 | 50 | 60 | 70 | 80 | 90 | 100 | 500

export type ShadedSystemColour = `${SystemColour}-${SystemShades}`
export type ShadedSystemBgColour = `bg-${ShadedSystemColour}`
export type TextColour = `text-${SystemColour}`

export type SystemColourMapping = {[type in SystemColour]: string}
export const systemColourMapping: SystemColourMapping = {
  grey: 'cft-component-grey',
  'grey-light': 'cft-component-grey-light',
  'grey-lighter': 'cft-component-grey-lighter',
  president: 'cft-component-president',
  'president-light': 'cft-component-president-light',
  'president-lighter': 'cft-component-president-lighter',
  blue: 'cft-component-blue',
  gold: 'cft-component-gold',
  grape: 'cft-component-grape',
  green: 'cft-component-green',
  'green-light': 'cft-component-green-light',
  'green-dark': 'cft-component-green-dark',
  orange: 'cft-component-orange',
  'orange-light': 'cft-component-orange-light',
  'orange-dark': 'cft-component-orange-dark',
  'orange-darker': 'cft-component-orange-darker',
  petrol: 'cft-component-petrol',
  primary: 'cft-component-primary',
  purple: 'cft-component-purple',
  red: 'cft-component-red',
  'red-light': 'cft-component-red-light',
  'red-dark': 'cft-component-red-dark',
  'red-darker': 'cft-component-red-darker',
  secondary: 'cft-component-secondary',
  vermilion: 'cft-component-vermilion',
  'vermilion-dark': 'cft-component-vermilion-dark',
  white: 'cft-component-white',
  yellow: 'cft-component-yellow',
  rivergreen: 'cft-component-rivergreen',
}
